<template>
  <AccessStateLayout
    description="Your browser is not supported. Please use Chrome or Firefox instead."
    eyebrow="Browser check"
    test-id="unsupported-browser-state"
    title="Unsupported browser"
  />
</template>

<script setup lang="ts">
import AccessStateLayout from './AccessStateLayout.vue';
</script>
